import React from "react";
import "./advertisement.scss";
import instaIcon from "../../../assets/images/instaIcon.svg";
import whatsappIcon from "../../../assets/images/whatsapp_icon.svg";
import enquiryIcon from "../../../assets/images/enquiryIcon.svg";
import fbIcon from "../../../assets/images/fb_icon.svg";
import directionIcon from "../../../assets/images/directionIcon.svg";
import connectButton from '../../../assets/images/app_connect_btn.png'
import interestButton from '../../../assets/images/products/interest_button.png'
import sliderdotImage from '../../../assets/images/slider_dot_img.png'
import locationIcon from '../../../assets/images/location_icon.png'
import sentIcon from '../../../assets/images/sent_icon.svg'
import contactIcon from '../../../assets/images/contact_icon_white.png'

const Advertisement = ({
  src,
  action,
  poster,
  icon,
  title,
  iconUpdated = null,
  profileData = null, // Add profile data prop
}) => {
  // Generate random match percentage between 20 and 90
  const getRandomMatchPercentage = () => {
    return Math.floor(Math.random() * (90 - 20 + 1)) + 20;
  }

  // Get color based on match percentage
  const getMatchPercentageColor = (percentage) => {
    if (percentage < 30) {
      return '#FF8888'; // Red for below 30
    } else if (percentage >= 30 && percentage <= 40) {
      return '#E2B339'; // Yellow/orange for 30-40
    } else if (percentage >= 80) {
      return '#17953A'; // Green for 80+
    }
    return ''; // Default color for other ranges
  }
  // Helper function to get the correct icon image
  const getIconImage = (icon) => {
    const iconMap = {
      whatsapp: whatsappIcon,
      instagram: instaIcon,
      enquiry: enquiryIcon,
      facebook: fbIcon,
      direction: directionIcon,
    };
    // const title = {
    //     whatsapp: whatsappIcon,
    //     instagram: instaIcon,
    //     enquiry: 'Enquiry',
    //     facebook: 'Contact on facebook',
    //     direction: directionIcon,
    // }

    return iconMap[icon] || null; // Return the image or null if not found
  };

  const iconImage = getIconImage(icon);

  // Normalize height display to "Xft Y in" (strip cm part if present)
  const formatHeight = (height) => {
    if (!height) return null;
    const label = typeof height === 'object' ? (height.label || height.value || height.name) : height;
    if (!label || typeof label !== 'string') return null;

    let text = label.trim();

    // If format like "126 cm / 4 ft 2 in" -> take part after '/'
    if (text.includes('/')) {
      const parts = text.split('/');
      text = parts[parts.length - 1].trim();
    }

    // If format like 5'6" -> convert to 5ft 6 in
    const feetInchesMatch = text.match(/^(\d+)\s*'\s*(\d+)\s*"?$/);
    if (feetInchesMatch) {
      const [, ft, inch] = feetInchesMatch;
      return `${ft}ft ${inch} in`;
    }

    // If already like "4 ft 2 in" -> normalize spacing to Xft Y in
    const imperialMatch = text.match(/(\d+)\s*ft\s*(?:([0-9]{1,2})\s*in)?/i);
    if (imperialMatch) {
      const ft = imperialMatch[1];
      const inch = imperialMatch[2];
      return inch !== undefined ? `${ft}ft ${inch} in` : `${ft}ft`;
    }

    // Fallback: remove any trailing cm portion if provided first
    const cmRemoved = text.replace(/\b\d+\s*cm\b.*$/i, '').trim();
    return cmRemoved || text;
  };

  let advertisementAction;
  switch (action) {
    case "enquiry":
      advertisementAction = "enq";
      break;
    case "whatsapp":
      advertisementAction = "wp";
      break;
    case "instagram":
      advertisementAction = "inst";
      break;
    case "phone":
      advertisementAction = "phn";
      break;
    case "direction":
      advertisementAction = "dir";
      break;
    default:
      break;
  }

  return (
    <div className="add_display red_shadow app__match-card static">
      <figure>
        <img src={poster} alt="" className="img_full cover" />
        <span className='app__contact_icon advertisement__contact_icon'>
          <img src={contactIcon} alt="contact icon" />
        </span>
      </figure>
      <div className="app__match-info">
        {(() => {
          const percentage = getRandomMatchPercentage();
          const backgroundColor = getMatchPercentageColor(percentage);
          return (
            <div className='match_percentage_wrap'>
              <div className="match_percentage">
                <span style={{ backgroundColor: backgroundColor }}>{percentage}%</span>
                <span>Match</span>
              </div>
            </div>
          );
        })()}
        <div className="app__match-id text_blue200">Bureau Profile</div>
        <div className="app__match-name">{profileData?.name || profileData?.lumi_id || 'AD123456'}</div>
        <div className="app__match-details">
          <div className='app__info_wrap'>
            <div className="app__match-age">{profileData?.age ? `${profileData.age} yrs` : '25 yrs'}</div>
            <span className="divider text_red">|</span>
            <div className="app__match-height">
              {formatHeight(profileData?.height) || '5ft 6 in'}
            </div>
            <span className="divider text_red">|</span>
            <div className="app__match-status">
              {profileData?.marital_status?.label || profileData?.marital_status || 'Single'}
            </div>
          </div>
          <div className="app__match-religion">
            {(() => {
              const religion = profileData?.religion?.label || profileData?.religion;
              const caste = profileData?.caste?.label || profileData?.caste;
              if (religion && caste) {
                return `${religion}, ${caste}`;
              }
              return religion || 'Hindu';
            })()}
          </div>
          <div className="app__match-profession">
            {profileData?.job?.label || profileData?.job || 'Software Engineer'}
          </div>
          <div className="short_location_wrap">
            <span><img src={locationIcon} alt="location icon" /></span>
            <div className="app__match-location">
              {(() => {
                const city = profileData?.city?.label || profileData?.city;
                const state = profileData?.state?.label || profileData?.state;
                if (city && state) {
                  return `${city}, ${state}`;
                }
                return city || state || profileData?.location || 'Mumbai, Maharashtra';
              })()}
            </div>
          </div>
          <div className="app__match-connect">
            <img src={interestButton} alt="interest button" />
          </div>
          <span className='slider_dot'>
            <img src={sliderdotImage} alt="slider dot" />
          </span>
        </div>
        <div className="app__match-last-online">
          Last online: Recently
        </div>
      </div>
      {/* <div
        className={`ad_bottom ${advertisementAction}`}
        style={{ background: "#2F8AF4" }}
      >
        <span>
          {iconUpdated ? (
            <span className="icon_updated">
              <img src={sentIcon} alt="icon" className="img_full contain" />
            </span>
          ) : (
            <span className="icon">
              {iconImage && (
                <img src={iconImage} alt="icon" className="img_full contain" />
              )}
            </span>
          )}

          <span style={{ textTransform: "capitalize" }}>{title || ""}</span>
        </span>

        <span className="icon_updated" style={{marginLeft: 'auto' , display: 'flex'}}>
              <img src={sentIcon} alt="icon" className="img_full contain" style={{ width: '18px', height: '18px' }} />
            </span>
      </div> */}
    </div>
  );
};

export default Advertisement;
